import OrderOnlineSection from "../components/Online/OrderOnlineSection";

export default function OrderOnlinePage(){
    return (
        <>
        <OrderOnlineSection/>
        </>
    )
}